import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

const NotFoundPage = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-gray-50">
      <SEOHead
        title="Page Not Found — StageCrew"
        description="The page you're looking for doesn't exist or has been moved. Browse AV technician and stagehand gigs on StageCrew."
        url="https://stagecrew.app/404"
        canonical={false}
        robots="noindex,follow"
      />
      <div className="text-center px-4">
        <p aria-hidden="true" className="text-9xl font-bold text-blue-600">404</p>
        <h1 className="text-3xl font-bold text-gray-800 mt-4">Page Not Found</h1>
        <p className="text-gray-600 mt-2 mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="space-x-4">
          <Link
            to="/"
            className="bg-blue-600 text-white px-6 py-3 rounded font-semibold hover:bg-blue-700 inline-block"
          >
            Go Home
          </Link>
          <Link
            to="/jobs"
            className="bg-gray-200 text-gray-800 px-6 py-3 rounded font-semibold hover:bg-gray-300 inline-block"
          >
            Browse Jobs
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
